import { z } from 'zod'

import { ChannelStatus } from 'common/core/interfaces/channelStatuses'

const telegramChannelSchema = z
  .object({
    bot_name: z.string(),
    bot_username: z.string(),
    is_channel_connected: z.boolean(),
    ts_channel_connected: z.string().nullable(),
    is_channel_enabled: z.boolean(),
    status: z.nativeEnum(ChannelStatus),
    // todo api
    default_reply: z.any(),
    // todo api
    welcome_message: z.any(),
  })
  .strict()

export const TelegramApiSchemas = {
  toggleChannel: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      state: z.boolean(),
    }),
    response: telegramChannelSchema,
  },
  updateToken: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      token: z.string(),
    }),
    response: telegramChannelSchema,
  },
  getSignUpUrl: {
    path: z.undefined(),
    query: z.object({
      is_signup: z.boolean().optional(),
      return: z.string().optional(),
    }),
    request: z.undefined(),
    response: z.object({ url: z.string() }),
  },
  getTelegramBindingRefUrl: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ code: z.string(), url: z.string() }),
  },
  getOptInUrl: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ url: z.string() }),
  },
  optOut: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.undefined(),
  },
}

export type TelegramChannel = z.infer<typeof telegramChannelSchema>
